<script lang="ts">
	import VoiceSample, { VoiceSampleButtonType } from '../VoiceSample.svelte'
	import { t } from 'svelte-i18n'

	interface Props {
		row: Record<string, string>
		key: string
	}

	let { row, key }: Props = $props()

	const currentVoiceSample = $derived(row[key])
</script>

<VoiceSample
	voiceSample={currentVoiceSample}
	voiceSampleButtonType={VoiceSampleButtonType.SMALL}
	buttonText={$t('PersonaForm.voiceSample')}
/>
